import { render } from "./index.vue?vue&type=template&id=b6a87510&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=b6a87510&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6a87510"],['__file',"src/views/widget/wechatQrCode/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b6a87510"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b6a87510', __exports__)) {
    console.log('reload')
    api.reload('b6a87510', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=b6a87510&scoped=true", () => {
    console.log('re-render')
    api.rerender('b6a87510', render)
  })

}


export default __exports__